export default __webpack_public_path__ + "static/media/trener12.108f1a65.png";